// extracted by mini-css-extract-plugin
export default {"SectionContainer":"UserSettingsForm_SectionContainer__oDAzi","MainRow":"UserSettingsForm_MainRow__hM2cl","InputsWrapper":"UserSettingsForm_InputsWrapper__jbenb"};